import styled from 'styled-components';
import { color } from '@magalu/stereo-ui-styles';
import Text from '../../atoms/Text';
import LinkComponent from '../../atoms/Link';
export const Container = styled.footer`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  line-height: 1.2;
  font-size: 12px;
  font-weight: 400;
  text-align: center;
  overflow: hidden;
  ${color}
`;
export const Rules = styled(Text)`
  padding: 20px 8px;
  ${color}
`;
export const Policy = styled(LinkComponent)`
  text-decoration: underline;
  font-size: unset;
  ${color}
`;
export const Link = styled(LinkComponent)`
  margin: 8px;
  text-decoration: underline;
  font-size: unset;
  ${color}
`;
export const Address = styled.address`
  padding: 20px 8px;
`;
export const Line = styled(Text)`
  ${color}
`;